export const IDE_URL = "https://trywale.com"
export const DIS_INV = "https://discord.gg/D7V2BMFC"
export const TWEET_URL = "https://twitter.com/trydyno"